import React from "react";
import ContactForm from "../components/ContactForm";

function Contact() {
  return (
    <>
      <header className="relative">
        <h1>Let's get in touch! </h1>
      </header>
      <ContactForm />
    </>
  );
}

export default Contact;
